<template>
  <div class="table-container">
    <b-overlay center :show="isLoading" rounded="sm">
      <div v-if="!isLoading">
        <validation-observer ref="observer" v-slot="{ invalid, handleSubmit }">
          <b-form @submit.prevent="">
            <b-card header-tag="header">
              <template #header>
                <b>Contenuto</b>
              </template>
              <b-card-text>
                <b-row>
                  <div class="form-group">
                    <base-input
                      name="title"
                      vid="title"
                      label="Titolo"
                      v-model="form[rep].title"
                      placeholder="Inserisci un titolo"
                      :rules="{ required: true }"
                    />
                  </div>
                </b-row>
                <b-row>
                  <div
                    class="col-m-6 mt-3 form-group d-flex align-items-center justify-content-between"
                  >
                    <base-form-file
                      v-model="form[rep].image"
                      vid="base_form_file"
                      style="padding: 0; width: 290px"
                      :state="Boolean(form[rep].image)"
                      placeholder="Scegli un file o trascinalo qui..."
                      drop-placeholder="Trascina il file qui..."
                      browse-text="Naviga"
                    ></base-form-file>
                    <b-button
                      size="sm"
                      class="mt-1 btn--transparent btn--smaller btn--x-smaller btn-reset"
                      @click="form[rep].image = null"
                      :disabled="!form[rep].image"
                    >
                      Reset
                    </b-button>
                  </div>
                </b-row>
              </b-card-text>
            </b-card>
            <div class="form-actions form-actions--sticky">
              <div class="inner-wrapper">
                <div>
                  <span
                    :title="`${
                      invalid
                        ? 'Compila correttamente i campi per poter salvare'
                        : 'Invia il form'
                    }`"
                  >
                    <b-button
                      @click="handleSubmit(onSubmit)"
                      type="button"
                      :disabled="invalid || (form[rep].title && !validName)"
                      variant="lisaweb"
                      size="sm"
                    >
                      Salva
                    </b-button>
                  </span>
                  <b-button
                    @click="resetForm()"
                    type="button"
                    lass="btn--transparent btn-reset"
                    size="sm"
                    >Reset
                  </b-button>
                </div>
                <div>
                  <b-button
                    @click="$router.back()"
                    class="btn--transparent"
                    type="button"
                    title="Torna alla pagina precedente"
                  >
                    <b-icon-chevron-double-left
                      font-scale="0.9"
                    ></b-icon-chevron-double-left>
                    Torna indietro
                  </b-button>
                </div>
              </div>
            </div>
          </b-form>
        </validation-observer>
      </div>
      <template #overlay>
        <div class="text-center">
          <div class="custom-loader"></div>
          <p class="loading-text">Operazione in corso...</p>
        </div>
      </template>
    </b-overlay>
  </div>
</template>

<script>
import ShortcutMixin from "@/mixins/ShortcutMixin";
import FormMixin from "@/mixins/FormMixin";
import BaseInput from "@/components/form/BaseInput";
import LisaComunicaMixin from "@/mixins/LisaComunicaMixin";
import BaseFormFile from "../../../form/BaseFormFile.vue";

export default {
  mixins: [FormMixin, ShortcutMixin, LisaComunicaMixin],
  data() {
    return {
      repository: "image",
      id: this.$route.params.id,
      form: {
        image: {
          title: null,
          image: null,
        },
      },
      fields: [
        {
          key: "filesystem",
          thStyle: {
            display: "none",
          },
          tdClass: "col-md-3",
        },
        {
          key: "delete",
          thStyle: {
            display: "none",
          },
          tdClass: "col-md-3",
        },
      ],
      items: [{ file: null }],
    };
  },
  components: {
    BaseFormFile,
    BaseInput,
  },
  methods: {
    onSubmit() {
      this.isLoading = true;
      this.form[this.rep].image = this.items[0].file;
      let formData = new FormData();
      formData.append("title", this.form[this.rep].title);
      formData.append("image", this.form[this.rep].image);
      this.update(formData)
        .then(() => {
          this.isLoading = false;
          this.$showSnackbar({
            preset: "success",
            text: `Azione Completata: Immagine Modificata`,
          });
          this.shortcut("lisacomunica_template", null, "#Image", "filterImage");
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
          this.isLoading = false;
        });
    },
  },
  created() {
    this.show()
      .then((response) => {
        this.form[this.rep].title = response.data.content.title;
        this.form[this.rep].image = [response.data.content.url];
        this.isLoading = false;
      })
      .catch((error) => {
        let errMsg = this.$getErrorMessage(error);
        this.$showSnackbar({
          preset: "error",
          text: `${errMsg}`,
        });
        this.isLoading = false;
        this.ok = true;
      });
  },
  computed: {
    rep() {
      return this.repository;
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(tbody) {
  border-top: 0px !important;
}

:deep(table td) {
  border-top: 0px solid var(--color-border);
}
</style>
